export const ALERT_TYPES = {
  NEGATIVE: 'NEGATIVE',
  UNREAD: 'UNREAD',
  TOTAL: 'TOTAL',
}

export const ALERT_TYPES_COLORS = {
  NEGATIVE: '#E0505B',
  UNREAD: '#0553A5',
  TOTAL: 'TOTAL',
}

export const COLUMN_IDS = {
  STT: 'STT',
  SUBJECT: 'subjectName',
  TYPE_DESCRIPTION: 'TYPE_DESCRIPTION',
  DATE: 'createDate',
  TRIGGER: 'profilePortfoliosList',
}

export const SENTIMENT_TYPE_ID = {
  POSITIVE: 1,
  NEGATIVE: 2,
  INFORMATIVE: 3,
}
